module.exports = __webpack_public_path__ + "img/au06.bf73cf59.jpg";